// CANONICAL COPY (GH #7115). src/constants/obligations/obl-endpoint-device-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-endpoint-device-security',
  title: 'Verify security of user endpoint devices',
  description:
    'Confirm that information stored on, processed by or accessible via user endpoint devices — desktops, laptops, tablets and mobile phones — is protected through appropriate technical and procedural controls. Controls shall include device registration, full-disk encryption, endpoint protection software, automatic session locking, remote-wipe capability for mobile devices, patching obligations, restrictions on BYOD where permitted and user responsibilities for lost / stolen devices. Review the endpoint device standard and configuration compliance evidence.',
  category: 'technical',
  scfIds: ['SCF-OPS-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'User endpoint device standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
